import { put } from 'redux-saga/effects'

import Internal from 'common/modules/internal'

export function* watchNetworkRequestSuccess(payload) {
    const { id, response } = payload

    yield put(Internal.creators.sendMessage({
        payload: {
            id,
            payload: {
                response: {
                    data: { ...response.data },
                    headers: { ...response.headers },
                    request: { ...response.request },
                    status: { ...response.status },
                    statusText: { ...response.statusText },
                },
            },
        },
    }))
}

export function* watchNetworkRequestError(payload) {
    const { id, error: { response } } = payload

    yield put(Internal.creators.sendMessage({
        payload: {
            id,
            payload: {
                response: {
                    data: response?.data || 'network error',
                },
            },
        },
    }))
}
